import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "user-form email-setts" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)
const _hoisted_5 = { class: "p-4 setting-data" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "flex-fill" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, null, -1)
const _hoisted_10 = {
  class: "form-horizontal",
  id: "frmPrefs",
  name: "frmPrefs",
  role: "form"
}
const _hoisted_11 = { class: "card p-4" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-6 form-group" }
const _hoisted_14 = { for: "ShortName" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { class: "col-md-6 form-group" }
const _hoisted_17 = { for: "CompanyName" }
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { for: "Email" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = {
  key: 0,
  class: "error-style"
}
const _hoisted_23 = { for: "Country" }
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  key: 0,
  class: "error-style"
}
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = { for: "Adress" }
const _hoisted_28 = ["placeholder"]
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-6 form-group" }
const _hoisted_31 = { for: "City" }
const _hoisted_32 = ["placeholder"]
const _hoisted_33 = { for: "AcctCurrency" }
const _hoisted_34 = ["value"]
const _hoisted_35 = {
  key: 0,
  class: "error-style"
}
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { for: "MobilePhone" }
const _hoisted_38 = ["placeholder"]
const _hoisted_39 = {
  key: 0,
  class: "error-style"
}
const _hoisted_40 = { for: "OfficePhone" }
const _hoisted_41 = ["placeholder"]
const _hoisted_42 = {
  key: 0,
  class: "error-style"
}
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { for: "Fax" }
const _hoisted_45 = ["placeholder"]
const _hoisted_46 = {
  key: 0,
  class: "error-style"
}
const _hoisted_47 = { class: "col-md-6 form-group" }
const _hoisted_48 = { for: "POBox" }
const _hoisted_49 = ["placeholder"]
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-md-6 form-group" }
const _hoisted_52 = { for: "VATNumber" }
const _hoisted_53 = ["placeholder"]
const _hoisted_54 = { class: "col-md-6 form-group" }
const _hoisted_55 = { for: "Website" }
const _hoisted_56 = ["placeholder"]
const _hoisted_57 = { class: "margin-btm-20" }
const _hoisted_58 = { class: "container-fluid" }
const _hoisted_59 = { class: "d-flex" }
const _hoisted_60 = { class: "flex-fill" }
const _hoisted_61 = ["title"]
const _hoisted_62 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_63 = { class: "img-receiver-wrapper2 no-margin-left" }
const _hoisted_64 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.isStartLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'spinner'],
          class: "fs-6-x"
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("h2", null, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'bank'],
              class: "d-inline-block me-1"
            }),
            _createTextVNode("  " + _toDisplayString(_ctx.language.my_comp_setts), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.language.my_comp_setts_msg), 1),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.language.my_comp_setts), 1),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "btn-xs",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reloadPage()))
              }, [
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(_ctx.language.refresh), 1)
              ]),
              _createTextVNode("  "),
              _createElementVNode("button", {
                class: "btn-xs",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveMyCompanySettings())),
                disabled: false
              }, [
                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-save'] }),
                _createTextVNode(" " + _toDisplayString(_ctx.language.save), 1)
              ])
            ])
          ]),
          _hoisted_9,
          _createElementVNode("form", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.language.short_name), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "ShortName",
                    name: "ShortName",
                    placeholder: _ctx.language.short_name.toLowerCase(),
                    class: "form-control selectallfocus",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.myCompanyData.ShortName) = $event)),
                    autocomplete: "off",
                    disabled: true,
                    onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectOnFocus($event)))
                  }, null, 40, _hoisted_15), [
                    [_vModelText, _ctx.myCompanyData.ShortName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.language.company_name), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "CompanyName",
                    name: "CompanyName",
                    placeholder: _ctx.language.company_name.toLowerCase(),
                    class: "form-control selectallfocus",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.myCompanyData.CompanyName) = $event)),
                    autocomplete: "off",
                    disabled: true,
                    onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectOnFocus($event)))
                  }, null, 40, _hoisted_18), [
                    [_vModelText, _ctx.myCompanyData.CompanyName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", {
                  class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.myCompanyData.Email.$error}])
                }, [
                  _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.language.email), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    id: "Email",
                    name: "Email",
                    placeholder: _ctx.language.email.toLowerCase(),
                    class: _normalizeClass(["form-control selectallfocus", {'input-error': _ctx.v$.myCompanyData.Email.$error}]),
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.myCompanyData.Email) = $event)),
                    autocomplete: "off",
                    onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectOnFocus($event)))
                  }, null, 42, _hoisted_21), [
                    [_vModelText, _ctx.myCompanyData.Email]
                  ]),
                  (_ctx.v$.myCompanyData.Email.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.v$.myCompanyData.Email.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.myCompanyData.Country.$error}])
                }, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.language.country), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "Country",
                    name: "Country",
                    class: _normalizeClass(["form-control-sel selectallfocus", {'input-error': _ctx.v$.myCompanyData.Country.$error}]),
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.myCompanyData.Country) = $event)),
                    autocomplete: "off"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstTelCodes, (ctry) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: ctry.code,
                        key: ctry.code
                      }, _toDisplayString(ctry.name), 9, _hoisted_24))
                    }), 128))
                  ], 2), [
                    [_vModelSelect, _ctx.myCompanyData.Country]
                  ]),
                  (_ctx.v$.myCompanyData.Country.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.v$.myCompanyData.Country.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.language.address), 1),
                _withDirectives(_createElementVNode("textarea", {
                  id: "Adress",
                  name: "Adress",
                  placeholder: _ctx.language.address.toLowerCase(),
                  class: "form-control selectallfocus",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.myCompanyData.Adress) = $event)),
                  maxlength: "250",
                  autocomplete: "off",
                  rows: "2",
                  onFocus: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectOnFocus($event)))
                }, null, 40, _hoisted_28), [
                  [_vModelText, _ctx.myCompanyData.Adress]
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.language.city), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "City",
                    name: "City",
                    placeholder: _ctx.language.city.toLowerCase(),
                    class: "form-control selectallfocus",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.myCompanyData.City) = $event)),
                    maxlength: "15",
                    autocomplete: "off",
                    onFocus: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectOnFocus($event)))
                  }, null, 40, _hoisted_32), [
                    [_vModelText, _ctx.myCompanyData.City]
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.myCompanyData.AcctCurrency.$error}])
                }, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.language.currency), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "AcctCurrency",
                    name: "AcctCurrency",
                    class: _normalizeClass(["form-control-sel selectallfocus", {'input-error': _ctx.v$.myCompanyData.AcctCurrency.$error}]),
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.myCompanyData.AcctCurrency) = $event)),
                    autocomplete: "off"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstCurrencies, (crcy) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: crcy.code,
                        key: crcy.code
                      }, _toDisplayString(crcy.name), 9, _hoisted_34))
                    }), 128))
                  ], 2), [
                    [_vModelSelect, _ctx.myCompanyData.AcctCurrency]
                  ]),
                  (_ctx.v$.myCompanyData.AcctCurrency.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.v$.myCompanyData.AcctCurrency.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", {
                  class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.myCompanyData.MobilePhone.$error}])
                }, [
                  _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.language.mobilePhone), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "MobilePhone",
                    name: "MobilePhone",
                    placeholder: _ctx.language.mobilePhone.toLowerCase(),
                    class: _normalizeClass(["form-control selectallfocus", {'input-error': _ctx.v$.myCompanyData.MobilePhone.$error}]),
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.myCompanyData.MobilePhone) = $event)),
                    autocomplete: "off",
                    onFocus: _cache[15] || (_cache[15] = ($event: any) => (_ctx.selectOnFocus($event)))
                  }, null, 42, _hoisted_38), [
                    [_vModelText, _ctx.myCompanyData.MobilePhone]
                  ]),
                  (_ctx.v$.myCompanyData.MobilePhone.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.v$.myCompanyData.MobilePhone.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.myCompanyData.OfficePhone.$error}])
                }, [
                  _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.language.office_phone), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "OfficePhone",
                    name: "OfficePhone",
                    placeholder: _ctx.language.office_phone.toLowerCase(),
                    class: _normalizeClass(["form-control selectallfocus telephone-nbr", {'input-error': _ctx.v$.myCompanyData.OfficePhone.$error}]),
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.myCompanyData.OfficePhone) = $event)),
                    maxlength: "12",
                    autocomplete: "off",
                    onFocus: _cache[17] || (_cache[17] = ($event: any) => (_ctx.selectOnFocus($event)))
                  }, null, 42, _hoisted_41), [
                    [_vModelText, _ctx.myCompanyData.OfficePhone]
                  ]),
                  (_ctx.v$.myCompanyData.OfficePhone.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.v$.myCompanyData.OfficePhone.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", {
                  class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.myCompanyData.Fax.$error}])
                }, [
                  _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.language.fax), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "Fax",
                    name: "Fax",
                    placeholder: _ctx.language.fax.toLowerCase(),
                    class: _normalizeClass(["form-control selectallfocus telephone-nbr", {'input-error': _ctx.v$.myCompanyData.Fax.$error}]),
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.myCompanyData.Fax) = $event)),
                    maxlength: "12",
                    autocomplete: "off",
                    onFocus: _cache[19] || (_cache[19] = ($event: any) => (_ctx.selectOnFocus($event)))
                  }, null, 42, _hoisted_45), [
                    [_vModelText, _ctx.myCompanyData.Fax]
                  ]),
                  (_ctx.v$.myCompanyData.Fax.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.v$.myCompanyData.Fax.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.language.po_box), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "POBox",
                    name: "POBox",
                    placeholder: _ctx.language.po_box.toLowerCase(),
                    class: "form-control selectallfocus capletter",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.myCompanyData.POBox) = $event)),
                    maxlength: "10",
                    autocomplete: "off",
                    onFocus: _cache[21] || (_cache[21] = ($event: any) => (_ctx.selectOnFocus($event)))
                  }, null, 40, _hoisted_49), [
                    [_vModelText, _ctx.myCompanyData.POBox]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.language.tax_number), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "VATNumber",
                    name: "VATNumber",
                    placeholder: _ctx.language.tax_number.toLowerCase(),
                    class: "form-control selectallfocus telephone-nbr",
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.myCompanyData.VATNumber) = $event)),
                    maxlength: "15",
                    autocomplete: "off",
                    onFocus: _cache[23] || (_cache[23] = ($event: any) => (_ctx.selectOnFocus($event)))
                  }, null, 40, _hoisted_53), [
                    [_vModelText, _ctx.myCompanyData.VATNumber]
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.language.website), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "url",
                    id: "Website",
                    name: "Website",
                    placeholder: _ctx.language.website.toLowerCase(),
                    class: "form-control selectallfocus",
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.myCompanyData.Website) = $event)),
                    maxlength: "50",
                    autocomplete: "off",
                    onFocus: _cache[25] || (_cache[25] = ($event: any) => (_ctx.selectOnFocus($event)))
                  }, null, 40, _hoisted_56), [
                    [_vModelText, _ctx.myCompanyData.Website]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("h6", _hoisted_60, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.language.logo), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.saveCompanyLogoPhoto && _ctx.saveCompanyLogoPhoto(...args))),
                        title: _ctx.language.save
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-save'] })
                      ], 8, _hoisted_61)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("input", {
                        type: "file",
                        id: "CompanyLogoPhoto",
                        class: "file_show_field",
                        name: "CompanyLogoPhoto",
                        accept: "image/*",
                        onChange: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.selectCompanyLogoPhotoFilePath && _ctx.selectCompanyLogoPhotoFilePath(...args)))
                      }, null, 32),
                      _createElementVNode("img", {
                        ref: "imageSelector",
                        src: _ctx.companyLogoPath,
                        class: "image_from_file",
                        alt: ""
                      }, null, 8, _hoisted_64)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
}